import { Box, Spinner } from '@forgeglobal/design-framework';
import { useOktaAuth } from '@okta/okta-react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const DOCUSIGN_SIGNING_COMPLETE_EVENT = 'signing_complete';
const NON_COMPLETE_EVENTS = new Set([
  'cancel',
  'decline',
  'session_timeout',
  'ttl_expired',
  'viewing_complete',
  'fax_pending',
]);

export const FundingRequestCompleted = () => {
  const { authState } = useOktaAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authState) {
      return;
    }

    // When loaded inside the DocuSign iframe, TransfersInCashDialog's onLoad
    // handler detects this returnUrl and drives navigation from the parent
    // document. Skip here to avoid double-navigation.
    if (window.self !== window.top) {
      return;
    }

    if (authState?.isAuthenticated) {
      const searchParams = new URLSearchParams(window.location.search);
      const event = (searchParams.get('event') || '').toLowerCase();
      const isSigningComplete = event === DOCUSIGN_SIGNING_COMPLETE_EVENT;
      const isNonCompleteEvent = NON_COMPLETE_EVENTS.has(event) || !event;
      const param = isSigningComplete
        ? 'transfers-in-cash-requested=true'
        : isNonCompleteEvent
          ? 'transfers-in-cash-requested=false&transfers-in-cash-declined=true'
          : 'transfers-in-cash-requested=false';

      navigate(`/funding?${param}`, { replace: true });
      return;
    }

    window.top.location.href = 'https://forgetrust.com';
  }, [authState, navigate]);

  return (
    <Box
      data-test-id="transfer-request-completed-container"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
      }}>
      <Spinner />
    </Box>
  );
};
